import React from 'react';

function Note(props: any) {
    const y = (props.columnEndTime - props.noteProp.JudgeTime) * props.scale;
    
    // Dynamic layout
    const xBase = props.noteProp.LanePosition * props.laneWidth + props.contentOffsetX; 
    const width = props.noteProp.Size * props.laneWidth;
    const visualWidth = Math.max(1, width - 2); 
    const visualX = xBase + 1;
    
    // Adaptive Height
    const dynamicHeight = Math.max(2, props.scale * 0.15); // Min 2px
    const renderHeight = dynamicHeight + 1;

    // Interaction properties
    const eventProps = {
        onMouseEnter: (e: React.MouseEvent) => props.onHover && props.onHover(e, props.noteProp),
        onMouseMove: (e: React.MouseEvent) => props.onHover && props.onHover(e, props.noteProp),
        onMouseLeave: () => props.onLeave && props.onLeave(),
        onClick: () => console.log(props.noteProp.JudgeTime),
        className: "cursor-pointer"
    };

    // Hit Box (Invisible)
    const hitHeight = Math.max(renderHeight, 10);
    const hitY = y - (hitHeight - renderHeight) / 2;

    if (props.noteProp.Type === 2) {
        // End of hold
        return (
            <g {...eventProps}>
                <rect x={visualX} y={y} width={visualWidth} height={renderHeight} fill={`rgba(${props.color.slice(4, -1)}, 0.5)`} />
                <line x1={visualX} y1={y} x2={visualX + visualWidth} y2={y} stroke="black" strokeWidth="1" />
                <rect x={visualX} y={hitY} width={visualWidth} height={hitHeight} fill="transparent" />
            </g>
        );
    } else if ([3, 4, 5].includes(props.noteProp.Type)) {
        // Hold Body
        return (
             <g {...eventProps}>
                <rect x={visualX} y={y} width={visualWidth} height={renderHeight} fill={`rgba(${props.color.slice(4, -1)}, 0.5)`} />
                <rect x={visualX} y={hitY} width={visualWidth} height={hitHeight} fill="transparent" />
            </g>
        );
    } else {
        // Single Note
        const yPos = y - (renderHeight / 2); 
        const hitYPos = y - (hitHeight / 2);
        return (
             <g {...eventProps}>
                <rect x={visualX} y={yPos} width={visualWidth} height={renderHeight} rx={2} fill={props.color} stroke="black" strokeWidth="0.5" />
                <rect x={visualX} y={hitYPos} width={visualWidth} height={hitHeight} fill="transparent" />
            </g>
        );
    }
}

export default Note;